import { defineMessages } from 'react-intl';

export const orderAgainBagButtonMessages = defineMessages({
  viewBagLabel: {
    defaultMessage: 'View bag',
    description: 'Order again | Tabs | Order tab | View bag button label',
  },
});
